export default {
    namespaced: true,
    state: {
      NumberOfServices: 0,
      SelectedService1:'',
      SelectedService2:'',
      SelectedServiceType1: '',
    },
    mutations: {
      numberOfServices(state, payload) {
        state.NumberOfServices = payload.value;
      },
      selectedService1(state, payload) {
        state.SelectedService1 = payload;
      },
      selectedService2(state, payload) {
        state.SelectedService2 = payload;
      },
      selectedServiceType1(state, payload) {
        state.SelectedServiceType1 = payload;
      }
    },
    actions: {
      numberOfServices(context, payload) {
        context.commit('numberOfServices', payload);
      },
      selectService1(context, payload) {
        context.commit('selectedService1', payload);
      },
      selectService2(context, payload) {
        context.commit('selectedService2', payload);
      },
      selectedServiceType1(context, payload) {
        context.commit('selectedServiceType1', payload);
      },
      clearSelectedServices(context) {
        context.commit('numberOfServices', 0);
        context.commit('selectedService1', '');
        context.commit('selectedService2', '');
        context.commit('selectedServiceType1', '');
      }
    },
    getters: {
      numberOfServices(state) {
        return state.NumberOfServices;
      },
      selectedService1(state) {
        return state.SelectedService1;
      },
      selectedService2(state) {
        return state.SelectedService2;
      },
      selectedServiceType1(state) {
        return state.SelectedServiceType1;
      },
      selectedServiceTypeId(state) {
        return state.SelectedService1 ? state.SelectedService1.TypeId : null;
      },
      selectedServiceTypeId2(state) {
        return state.SelectedService2 ? state.SelectedService2.TypeId : null;
      },
      serviceTypeForLookUp(state){
        let typeId = state.SelectedService1.TypeId;
        if(state.NumberOfServices > 1) {
          typeId = 400; //COMBO Service Type
        }
        return typeId;
      }

    },
  };
  